import React from 'react'
import ForecastData from '../features/forecastData'

export default function ForecastDataPage() {
    return (
        <ForecastData />
    )
}